<template>
  <div class="wrapper">
    <page-header :title="header.title" :add-button="header.addButton" />
    <filters />
    <inner-list
      :loading="loading"
      :results="results"
      :pagination="pagination"
      :getEditRoute="getEditRoute"
      :actions="actions"
      :empty-text="emptyText"
    />
  </div>
</template>
<script>
import InnerList from './InnerList'
import Filters from './Filters'
import { Course } from '@/api'
import PaginatedList from '@/components/layout/PaginatedList'

export default {
  extends: PaginatedList,
  components: {
    InnerList,
    Filters
  },
  data() {
    return {
      service: Course
    }
  },
  methods: {
    getEditRoute(item) {
      return `/admin/kursy/szczegoly/${item.id}/edytuj/`
    },
    actions(course) {
      return [
        {
          type: 'router-link',
          to: this.getEditRoute(course),
          text: 'edytuj'
        },
        {
          text: 'usuń',
          onClick: () => {
            this.deleteCourseConfirm(course)
          }
        }
      ]
    },
    deleteCourseConfirm(course) {
      this.$confirm({
        title: 'Usuń kurs',
        content:
          'Przypisane rezerwacje oraz materiały dydaktyczne zostaną usunięte.',
        okText: 'Usuń',
        cancelText: 'Anuluj',
        maskClosable: true,
        onOk: () => {
          this.deleteCourse(course)
        }
      })
    },
    deleteCourse(course) {
      Course.delete(course.id).then(() => {
        this.fetchData()
      })
    }
  },
  computed: {
    header() {
      let title = `Lista kursów`
      if (this.pagination.total) {
        title = `${title} <sup>(${this.pagination.total})</sup>`
      }
      return {
        addButton: {
          label: 'Dodaj kurs',
          route: {
            path: '/admin/dodaj-kurs/'
          }
        },
        title
      }
    },
    emptyText() {
      const { is_completed } = this.$route.query
      return is_completed ? 'Brak zakończonych kursów' : 'Brak kursów'
    }
  }
}
</script>
